import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "checked", "disabled", "label", "circularCheck", "checkSize", "activeCheckColor", "dataTest", "checkIcon"];
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Layout';
import { Text } from '../Typography';
const HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "HiddenCheckbox",
  componentId: "sc-1qbw46w-0"
})(["border:0;clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);
const CheckIcon = styled.svg.withConfig({
  displayName: "CheckIcon",
  componentId: "sc-1qbw46w-1"
})(["fill:none;stroke:#fff;stroke-width:3px;"]);
const checkedStyles = css(["background:", ";border-color:", ";", "{visibility:'visible';}"], props => {
  var _props$activeCheckCol;
  return props.disabled ? '#e2e4e5' : (_props$activeCheckCol = props.activeCheckColor) !== null && _props$activeCheckCol !== void 0 ? _props$activeCheckCol : '#b5dde8';
}, props => {
  var _props$activeCheckCol2;
  return props.disabled ? '#e2e4e5' : (_props$activeCheckCol2 = props.activeCheckColor) !== null && _props$activeCheckCol2 !== void 0 ? _props$activeCheckCol2 : '#b5dde8';
}, CheckIcon);
const uncheckedStyles = css(["background:#fff;border-color:#e2e4e5;", "{visibility:'hidden';}"], CheckIcon);
const StyledCheckbox = styled.div.withConfig({
  displayName: "StyledCheckbox",
  componentId: "sc-1qbw46w-2"
})(["display:inline-block;width:", ";height:", ";border-style:solid;border-width:1.5px;border-radius:", ";transition:all 150ms;opacity:", ";", ";", ":focus + &{box-shadow:0 0 0 2px #f4f4f4;}"], props => props.checkSize || '18px', props => props.checkSize || '18px', props => props.circularCheck ? props.checkSize : '4px', props => props.disabled && 0.6, props => props.checked ? checkedStyles : uncheckedStyles, HiddenCheckbox);
const Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-1qbw46w-3"
})(["display:flex;justify-content:flex-start;align-items:center;cursor:pointer;user-select:none;"]);
export const Checkbox = _ref => {
  let {
      className,
      checked,
      disabled,
      label,
      circularCheck,
      checkSize,
      activeCheckColor,
      dataTest,
      checkIcon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(Box, {
    paddingY: 2,
    width: "auto",
    className: className,
    "data-test": dataTest
  }, React.createElement(Label, null, React.createElement(HiddenCheckbox, _extends({
    checked: checked,
    disabled: disabled
  }, props)), React.createElement(StyledCheckbox, {
    checked: checked,
    disabled: disabled,
    circularCheck: circularCheck,
    checkSize: checkSize,
    activeCheckColor: activeCheckColor
  }, !checkIcon && React.createElement(CheckIcon, {
    viewBox: "0 0 24 24"
  }, React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })), checkIcon), label && React.createElement(Text, {
    wrapped: true,
    marginLeft: 2,
    paddingTop: "3px",
    lineHeight: 1,
    as: "span"
  }, label)));
};
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  dataTest: PropTypes.string,
  className: PropTypes.string,
  circularCheck: PropTypes.bool,
  checkSize: PropTypes.string,
  activeCheckColor: PropTypes.string,
  checkIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null, undefined])])
} : {};
Checkbox.defaultProps = {
  disabled: false,
  label: '',
  dataTest: '',
  className: '',
  circularCheck: false,
  checkSize: '18px',
  activeCheckColor: '#b5dde8',
  checkIcon: undefined
};